module.exports = __webpack_public_path__ + "static/media/ami_en.f8e45f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/AMI_assistant/assets/ami_en.png
// module id = 1452
// module chunks = 1